/**
 * Production-safe logger utility
 * Only logs in development mode
 */

const isDev = process.env.NODE_ENV === 'development';

const logger = {
  log: (...args) => {
    if (isDev) console.log(...args);
  },
  
  warn: (...args) => {
    if (isDev) console.warn(...args);
  },
  
  error: (...args) => {
    // Always log errors
    console.error(...args);
  },
  
  info: (...args) => {
    if (isDev) console.info(...args);
  },
  
  debug: (...args) => {
    if (isDev) console.debug(...args);
  },
  
  // Group logging
  group: (label) => {
    if (isDev) console.group(label);
  },
  
  groupEnd: () => {
    if (isDev) console.groupEnd();
  },
  
  // Table logging
  table: (data) => {
    if (isDev) console.table(data);
  }
};

export default logger;
